import { useMessageSource } from "react-message-source";
import { ApplicationFlows } from "../../../route/application/authenticated/application-flow/types";

export function usePageTitle(flowType: ApplicationFlows): string {
  const { getMessage } = useMessageSource();

  if (flowType === ApplicationFlows.ADDITIONAL_CA) {
    return getMessage("FlowHeader.additionalCardApplication");
  }

  if (flowType === ApplicationFlows.ADDITIONAL_BAA) {
    return getMessage("FlowHeader.additionalBasicAccountApplication");
  }

  if (flowType === ApplicationFlows.FIRST_BAA) {
    return getMessage("FlowHeader.basicAccountApplication");
  }
}
